// Этап 66.2: синергия-колоды бота. Делает PvE-соперника сильным и разным:
//   getBotDeck(heroId)   → 24 шаблона карт колоды Героя (для botDeck в createMatch).
//   pickStrongBotHero()  → случайный сильный Герой корпы (по баланс-прогону).
// Данные колод — в src/data/bot-decks-data.js (автоген из build-archetype-decks).

import { BOT_DECKS } from '../data/bot-decks-data.js';
import { cards as cardsDeus }      from '../data/cards-deus.js';
import { cards as cardsSyntetics } from '../data/cards-syntetics.js';
import { cards as cardsGlobal }    from '../data/cards-global.js';
import { cards as cardsLivlife }   from '../data/cards-livlife.js';
import { cards as cardsNeutral }   from '../data/cards-neutral.js';

const REG = new Map();
for (const c of [...cardsDeus, ...cardsSyntetics, ...cardsGlobal, ...cardsLivlife, ...cardsNeutral]) {
  if (c?.id && !REG.has(c.id)) REG.set(c.id, c);
}

// Сильные Герои по корпам (баланс-прогон Этап 66): 1-2 на корпу. Бот в PvE
// берёт случайного → игрок встречает разных сильных соперников.
export const STRONG_BOT_HEROES = [
  { faction: 'global',    heroId: 'global_mit'         },
  { faction: 'global',    heroId: 'global_iv'          },
  { faction: 'livlife',   heroId: 'livlife_zayn'       },
  { faction: 'livlife',   heroId: 'livlife_lisa'       },
  { faction: 'deus',      heroId: 'deus_kirosa'        },
  { faction: 'syntetics', heroId: 'syn_bishor'         },
  // Этап 66.7: нейтрал тоже попадается. Колода — консистентное общее агро
  // (рецепт неприменим, нет L/E/R), но в прогоне сильна (~83% vs рандом).
  { faction: 'neutral',   heroId: 'neutral_lider_ulicy' },
];

// 24 шаблона карт колоды Героя (или null если колоды нет / карта не найдена).
export function getBotDeck(heroId) {
  const list = BOT_DECKS[heroId];
  if (!Array.isArray(list)) return null;
  const tpls = [];
  for (const { id, count } of list) {
    const t = REG.get(id);
    if (!t) return null;
    for (let i = 0; i < count; i++) tpls.push(t);
  }
  return tpls.length === 24 ? tpls : null;
}

// Случайный сильный Герой корпы. excludeFaction — по возможности не та же
// корпа, что у игрока (разнообразие).
export function pickStrongBotHero(excludeFaction = null) {
  let pool = STRONG_BOT_HEROES;
  if (excludeFaction) {
    const filtered = pool.filter(h => h.faction !== excludeFaction);
    if (filtered.length > 0) pool = filtered;
  }
  return pool[Math.floor(Math.random() * pool.length)];
}
